import { AfterViewInit, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { MapService } from "../../../services/internal-services/map.service";
import { GeoService } from "../../../services/internal-services/geo.service";
import { IProjectAOI } from "../../../interfaces/i-project-aoi";
import { FormControl } from "@angular/forms";
import { debounceTime } from "rxjs";
import { MatCheckboxChange } from "@angular/material/checkbox";

@Component({
  selector: "app-dev-coverage-panel",
  templateUrl: "./coverage-panel.component.html",
  styleUrls: ["./coverage-panel.component.scss"],
  standalone: false,
})
export class CoveragePanelComponent implements OnInit, AfterViewInit, OnDestroy {
  collectionSearchControl = new FormControl("");

  layers: any[];

  filteredLayers: any[];

  private _enabledAOIs: IProjectAOI[];

  constructor(private mapService: MapService) {
    this.collectionSearchControl.valueChanges.pipe(debounceTime(1000)).subscribe((value) => {
      this.updateVisibleInformation(value);
    });
  }

  @Input()
  set enabledAOIs(aois: IProjectAOI[]) {
    this._enabledAOIs = aois;
    this.updateVisibleInformation();
  }

  get enabledAOIs(): IProjectAOI[] {
    return this._enabledAOIs;
  }

  ngOnInit(): void {
    //Create the coverage vectorLayer
    this.createCoverageLayer();
  }

  ngAfterViewInit(): void {
    const aux = this.mapService.getCollectionManager().getCollections();
    this.layers = Object.entries(
      aux
        .map((c) => ({
          ...c,
          painted: false,
          visible: false,
          disabled: true,
        }))
        .reduce((acc, item) => {
          const key = item.properties.layer;
          if (!acc[key]) {
            acc[key] = [];
          }
          acc[key].push(item);
          return acc;
        }, {}),
    ).map(([key, items]) => ({
      key,
      items,
      painted: false,
    }));

    if (this.enabledAOIs?.length > 0) {
      this.updateVisibleInformation();
    }
  }

  updateVisibleInformation(terms?: string) {
    const enabledAOISNames =
      this.enabledAOIs && this.enabledAOIs.length > 0 ? this.enabledAOIs.map((value) => value.name) : [];

    if (!terms) {
      terms = this.collectionSearchControl.getRawValue();
    }
    const lowerTerm = terms.toLowerCase().trim();

    if (!this.layers || this.layers.length === 0) {
      return;
    }

    this.filteredLayers = [...this.layers].map((layer) => {
      layer.items.forEach((item) => {
        item.visible = enabledAOISNames.includes(item.properties.collection);
        item.disabled = !item.properties.collection.toLowerCase().includes(lowerTerm) && lowerTerm.length > 0;
      });
      layer.items = layer.items.sort((a, b) => {
        const activeComparison = Number(b.visible) - Number(a.visible);
        if (activeComparison !== 0) {
          return activeComparison;
        }
      });

      const allDisabled = layer.items.every((i) => i.disabled);
      layer.disabled = allDisabled && lowerTerm.length > 0;
      return layer;
    });
  }

  ngOnDestroy(): void {
    //Remove the coverage vectorLayer
    this.destroyCoverageLayer();
  }

  goTo(collection) {
    const wktPolygon = GeoService.geoJSONFeatureToWKT(collection);
    this.mapService.fitToWktPolygon(wktPolygon);
  }

  changeCollectionCoverageStatus(collection: any, event: MatCheckboxChange) {
    collection.painted = event.checked;
    if (event.checked) {
      this.showCoverageCollection(collection);
    } else {
      this.hideCoverageCollection(collection);
    }
  }

  createCoverageLayer() {
    this.mapService.getCoreMap().createCoverageLayer();
  }

  destroyCoverageLayer() {
    this.mapService.getCoreMap().destroyCoverageLayer();
  }

  showCoverageCollection(collection) {
    this.mapService.getCoreMap().addCovFeature(collection);
  }

  hideCoverageCollection(collection) {
    this.mapService.getCoreMap().removeCovFeature(collection);
  }
}
